import config from "@/libs/config";
import type { NextPage, GetStaticProps } from "next";
import { SetNewPasswordPage, SignInPage } from "@/components/pages";
import useMoveToBizsolLoginIfWaitingState from "@/libs/bizsolLogin";
import useFixedAuth from "@/libs/useFixedAuth";
import useCheckAuth from "@/libs/useCheckAuth";
import { useRouter } from "next/router";
import { useRollbarContext } from "@rollbar/react";

const AllowedIDInternalRedirectURLs = [
  "/verify-email-address",
  "/change-to-admin",
];

const SignIn: NextPage = () => {
  useRollbarContext("sign-in");

  const { authStatus, newPasswordRequired } = useFixedAuth();

  const router = useRouter();

  // after logging-in, redirect to select-service preserving current query parameters
  // can be overridden in specific cases, see (1)
  let redirectToIfSignedIn: string = "/select-service";
  let redirectToIfSignedInParams: any = { ...router.query };

  // helper function
  const get = (key: string) => {
    const val = router.query[key];
    return Array.isArray(val) ? val[0] : val;
  };

  // (1) used by ID internally to redirect to a specific page after sign-in
  const queryToken = get("token");
  const queryRedirectURL = get("redirectUrl");

  if (
    queryRedirectURL &&
    AllowedIDInternalRedirectURLs.includes(queryRedirectURL)
  ) {
    redirectToIfSignedIn = queryRedirectURL;
    if (queryToken) redirectToIfSignedInParams.token = queryToken;
  }

  let isReadyToCheckAuth = true; // 認証状態によるページ遷移を判定可能な状態かどうか

  const usingBizsol = config.USING_BIZSOL;
  if (usingBizsol) {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- there is no issue since it is guaranteed that usingBizsol remains a constant value throughout its lifecycle.
    const { passed } = useMoveToBizsolLoginIfWaitingState({
      authStatus,
    });
    isReadyToCheckAuth = passed; // bizsol 連携待ちをチェックする場合、判定が終わるまでは not ready とする。
  }

  useCheckAuth({
    authStatus,
    redirectToIfSignedIn,
    redirectToIfSignedInParams,
    isNotReady: !isReadyToCheckAuth,
  });

  return newPasswordRequired ? <SetNewPasswordPage /> : <SignInPage />;
};

export default SignIn;

export const getStaticProps: GetStaticProps = async () => {
  const posts = {};
  return {
    props: { posts },
  };
};
